import React, { useState, useEffect } from 'react';
import streamBlob from '../shared/streamBlob';

/** Audio player for nodes that reference a RawFile blob (e.g. VideoCall recordings).
 *  Fetches the audio as a local blob URL so the browser can seek/show duration correctly
 *  (MediaRecorder WebM often lacks duration headers when streamed via SAS URL). */
export default function AudioBlobPlayer({ rawFileNodeId }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!rawFileNodeId) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    (async () => {
      try {
        // Stream the audio through the SDK backend (avoids Azurite CORS issues)
        const url = await streamBlob(rawFileNodeId);
        if (!cancelled) setBlobUrl(url);
      } catch (err) {
        if (!cancelled) setError(err.message || 'Failed to load audio');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
      // Revoke old blob URL to free memory
      setBlobUrl(prev => { if (prev) URL.revokeObjectURL(prev); return null; });
    };
  }, [rawFileNodeId]);

  if (loading) return <div style={{ padding: '8px 0', color: '#888', fontSize: 12 }}>Loading audio...</div>;
  if (error) return <div style={{ padding: '8px 0', color: '#c44', fontSize: 12 }}>Audio unavailable: {error}</div>;
  if (!blobUrl) return null;

  return (
    <div style={{ padding: '8px 0' }}>
      <audio controls preload="auto" style={{ width: '100%', borderRadius: 6 }} src={blobUrl} />
    </div>
  );
}
